import { createFileRoute } from "@tanstack/react-router"
import { AdminNewsletterPage } from "../features/admin/AdminNewsletterPage"

export const Route = createFileRoute("/_auth/admin/newsletters")({
  component: AdminNewsletterPage,
})
